import { createSlice } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------

const initialState = {
    testToDo: false,
    testResults: false,
    browseTests: false,
    jobList: false,
    qualifications: false,
    profile: false,
};

const slice = createSlice({
    name: 'tutorial',
    initialState,
    reducers: {
        setTestToDo(state, action) {
            state.testToDo = action.payload;
        },
        setTestResults(state, action) {
            state.testResults = action.payload
        },
        setBrowseTests(state, action) {
            state.browseTests = action.payload
        },
        setJobList(state, action) {
            state.jobList = action.payload
        },
        setQualifications(state, action) {
            state.qualifications = action.payload
        },
        setProfile(state, action) {
            state.profile = action.payload
        }
    },
});

// Reducer
export default slice.reducer;

// Actions
export const {
    setTestToDo, setTestResults, setBrowseTests, setJobList, setQualifications, setProfile
} = slice.actions;
